import { Home } from "lucide-react";
import { Link } from "@/i18n/routing";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Seo";

const NotFound = () => (
  <>
    <Seo title="Page not found" description="The page you are looking for could not be found." path="/404" />
    <section className="vc-container flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
      <span className="font-display text-7xl font-semibold text-brand">404</span>
      <h1 className="mt-4 text-3xl font-extrabold text-[hsl(var(--vc-ink))]">Page not found</h1>
      <p className="mt-2 max-w-md text-[hsl(var(--vc-slate))]">
        The page you&apos;re looking for doesn&apos;t exist or may have moved.
      </p>
      <Button asChild className="mt-6 bg-brand font-bold text-white hover:opacity-90" data-testid="notfound-home-btn">
        <Link to="/"><Home className="mr-2 h-4 w-4" /> Back to home</Link>
      </Button>
    </section>
  </>
);

export default NotFound;
